module.exports = __webpack_public_path__ + "img/card-vacanta-big.3f131d51.png";